export default __webpack_public_path__ + "static/media/18.fe2f58a0.jpg";